import React, { Component } from 'react'

import cx from 'classnames'

import './styles.scss'

class ResponsiveContainer extends Component {

  render () {
    const {
      children,

      nogap,
      white,
      withMargin,
      withMarginHor,
      withMarginVer,
      withPadding,
      withPaddingHor,
      withPaddingVer,
      centered,

      className,
      locator,
    } = this.props

    const classes = cx(
      'ResponsiveContainer',
      className,
      locator, {
        'ResponsiveContainer--nogap': nogap,
        'ResponsiveContainer--white': white,
        'ResponsiveContainer--withMarginHor': withMarginHor || withMargin,
        'ResponsiveContainer--withMarginVer': withMarginVer || withMargin,
        'ResponsiveContainer--withPaddingHor': withPaddingHor || withPadding,
        'ResponsiveContainer--withPaddingVer': withPaddingVer || withPadding,

      })

    return (
      <div className={classes}>
        {children}
      </div>
    )
  }
}

class Cell extends Component {

  render () {
    const {
      colSpanDesktop,
      colSpanTablet,
      colSpanMobile,

      children,

      className,
      locator,

      white,
      withMargin,
      withMarginHor,
      withMarginVer,
      withPadding,
      withPaddingHor,
      withPaddingVer,
      centered,
    } = this.props

    return (
      <div
        className={cx(
          'ResponsiveCell',
          className,
          locator,
          {
            [`ResponsiveCell-colSpanDesktop-${colSpanDesktop}`]: colSpanDesktop,
            [`ResponsiveCell-colSpanTablet-${colSpanTablet}`]: colSpanTablet,
            [`ResponsiveCell-colSpanMobile-${colSpanMobile}`]: colSpanMobile,
            'ResponsiveCell--white': white,
            'ResponsiveCell--withMarginHor': withMarginHor || withMargin,
            'ResponsiveCell--withMarginVer': withMarginVer || withMargin,
            'ResponsiveCell--withPaddingHor': withPaddingHor || withPadding,
            'ResponsiveCell--withPaddingVer': withPaddingVer || withPadding,
            'ResponsiveCell--centered': centered,
          }
      )}>
        {children}
      </div>
    )
  }

}

export {
  ResponsiveContainer,
  Cell,
}



// WEBPACK FOOTER //
// ./src/components/ResponsiveGrid/index.js